import "./assets/css/plugins/bootstrap.min.css";
import 'remixicon/fonts/remixicon.css'
import "./assets/scss/style.scss";
import Web3State from "./context/web3/web3State";
import UserState from "./context/user/userState";

import Router from "./Router/routes";
function App() {
  return (
    <>
    <UserState>
    <Web3State>
    <div className="App overflow-hidden">
      <Router />
    </div>
    </Web3State>
    </UserState>
    </>
  );
}

export default App;
